import { Divider } from "@material-ui/core";
import React from "react";

import { StyledGrid } from "components/simple";
import { color, fontSize, spacingDefaults } from "style/constants";
import SingleBHQScore from "./SingleBHQScore";

type Props = {
  score?: {
    timestamp: number;
    percentileScore: number;
    rawScore: number;
  };
};

// Removed Timestamp
const SCORES = ["percentileScore", "rawScore"];

const SCORE_NAME_MAPPING: any = {
  percentileScore: "Percentile Score",
  rawScore: "Raw Score (Average Milliseconds)"
};

const BrainHQAssessment: React.FC<Props> = ({ score }: Props) => {
  function getScore(val: string): any {
    const found = score && Object.entries(score).find(([key, _]) => key === val);

    return found ? found[1] : null;
  }

  return (
    <StyledGrid
      backgroundColor={color.WHITE}
      border={`solid 1px ${color.MUTEDGRAY}`}
      borderRadius="8px"
    >
      <StyledGrid item fontSize={fontSize.medium} padding={spacingDefaults.large}>
        <strong>BrainHQ Assessment</strong>
      </StyledGrid>

      <Divider />
      <StyledGrid padding={`0 ${spacingDefaults.large}`}>
        {SCORES.map((score, i) => (
          <>
            <SingleBHQScore key={score} name={SCORE_NAME_MAPPING[score]} score={getScore(score)} />
            {i < SCORES.length ? <Divider /> : null}
          </>
        ))}
      </StyledGrid>
    </StyledGrid>
  );
};

export default BrainHQAssessment;
